import React from 'react';

type Props = {
  onConferma: () => void;
  onAnnulla: () => void;
};

const ConfirmAddVenueDialog = ({ onConferma, onAnnulla }: Props) => {
  return (
    <div className="text-center">
      <h2 className="text-xl font-semibold mb-4">Conferma aggiunta</h2>
      <p className="mb-6">Sei sicuro di volerlo aggiungere al mercato di riferimento?</p>
      <div className="flex justify-center space-x-4">
        <button onClick={onAnnulla} className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded">
          Annulla
        </button>
        <button onClick={onConferma} className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded">
          Conferma
        </button>
      </div>
    </div>
  );
};

export default ConfirmAddVenueDialog;

